export default __webpack_public_path__ + "static/media/Logo-login-right.520a1b42.svg";